import "antd/dist/reset.css";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

// react-css-theme-switcher injects theme <link>s at this comment node. CRA's prod HTML
// minifier strips the <!--styles-insertion-point--> out of index.html, so recreate it when
// missing. ponytail: runtime guard, not a build-config rewrite.
const INSERTION_POINT = "styles-insertion-point";
if (
  !Array.from(document.head.childNodes).some(
    (n) => n.nodeType === 8 && n.nodeValue === INSERTION_POINT
  )
) {
  document.head.appendChild(document.createComment(INSERTION_POINT));
}

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  
    <App />
  
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
